import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CryptopunksAppBidData {
  punkIndices: number[];
  bidAmount: string;
  address: string;
  signature: string;
  chainId: number;
  auctionContract: string;
  stashContract: string;
  expiresAt: string;
  bidNonce: number;
  tag?: string;
  /** When listings-scraper feature is on, default true (omit = protected). */
  stashBidProtectionEnabled?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CryptopunksAppService {
  // Use backend proxy endpoint that uses Puppeteer
  private getApiUrl(): string {
    const graphUri = environment.alternativeListingsGraphURI || '';
    const baseUrl = graphUri.replace(/\/graphql$/, '');
    if (!baseUrl) {
      throw new Error('alternativeListingsGraphURI is not configured');
    }
    return `${baseUrl}/api/scraper/publish-bid-cryptopunks-app`;
  }

  constructor(private http: HttpClient) {}

  async publishBid(bidData: CryptopunksAppBidData): Promise<void> {
    try {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });

      const response = await firstValueFrom(
        this.http.post<{ success: boolean; error?: string }>(
          this.getApiUrl(),
          bidData,
          { headers }
        )
      );

      if (!response.success) {
        throw new Error(response.error || 'Failed to publish bid');
      }

      console.log('[CryptopunksAppService] Bid published successfully');
    } catch (error) {
      console.error('[CryptopunksAppService] Error publishing bid to cryptopunks.app:', error);
      throw error;
    }
  }
}

